import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowRight, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { GetTheApp } from '@/components/get-app';
import { getBrandMeta } from '@/brandMeta';
import { SUBSIDIARY_CODE } from '@/config';
import { getBrandAsset } from '@/themes';

// Public route - the invitation email and the registration QR code link here
export const Route = createFileRoute('/get-app')({
  component: GetAppPage,
});

const brand = getBrandMeta(SUBSIDIARY_CODE);

function GetAppPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-b from-primary/10 via-muted/30 to-muted/30">
      <Card className="w-full max-w-md overflow-hidden shadow-lg">
        <div className="border-b bg-primary/5 px-6 pt-8 pb-6 text-center">
          <img src={getBrandAsset('logo.svg')} alt="Logo" className="h-10 w-auto mx-auto mb-5" />
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/15 ring-8 ring-primary/5">
            <Smartphone className="h-6 w-6 text-primary" aria-hidden="true" />
          </div>
          <h1 className="text-xl font-semibold">Get the {brand.appName} app</h1>
          <p className="mt-1 text-sm text-muted-foreground">For iPhone and Android</p>
        </div>
        <CardContent className="pt-6">
          <GetTheApp />
        </CardContent>
        <div className="flex justify-center border-t bg-muted/40 px-6 py-3">
          <Button asChild variant="ghost" size="sm">
            <Link to="/login">
              Sign in on the web
              <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </Button>
        </div>
      </Card>
    </div>
  );
}
